/**
 * Writing Styles - i18n Configuration
 * 注册功能模块的多语言支持
 */

import { i18n } from '@/i18n';
import enUS from './locales/en-US';
import zhCN from './locales/zh-CN';
import zhTW from './locales/zh-TW';
import jaJP from './locales/ja-JP';

// 注册英文
i18n.global.mergeLocaleMessage('en', enUS);

// 注册简体中文
i18n.global.mergeLocaleMessage('cn', zhCN);

// 注册繁体中文
i18n.global.mergeLocaleMessage('tw', zhTW);

// 注册日文
i18n.global.mergeLocaleMessage('jp', jaJP);
